module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/eye-2811fb908e5bd56c8d7cf4cdafea9eb4.png";